<template>
  <section class="hero section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container-sm">
      <div class="hero-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <div class="hero-content">
          <div class="reveal-from-bottom mt-0 mb-16" data-reveal-delay="200">
            <c-image :src="require('@/assets/images/lost.svg')" :width="528" :height="396" />
          </div>
          <div class="container-xs">
            <h4 class="m-0 mb-16 reveal-from-bottom" data-reveal-delay="400">
              We looked everywhere but couldn't locate that page.
            </h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js';
import CImage from '@/components/elements/Image.vue';

export default {
  name: 'C404Hero',
  components: {
    CImage
  },
  mixins: [SectionProps]
};
</script>
